module.exports = __webpack_public_path__ + "img/type_right_1.770b44be.png";